import { IntegradorApontamento } from './../../../models/integrador-apontamento';
import { Component, OnInit, Input } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Cliente } from 'src/app/models/cliente';
import { ClienteCampoPersonalizadoSelecionado } from 'src/app/models/cliente-campo-personalizado-selecionado';
import { CRMBIService } from 'src/app/services/crm/crm-bi.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Observable } from 'rxjs';
import { IntegradorApontamentoService } from 'src/app/services/integrador-apontamento.service';

@Component({
  selector: "app-bi-integrador",
  templateUrl: "./bi-integrador.component.html",
  styleUrls: ["./bi-integrador.component.scss"],
})
export class BiIntegradorComponent implements OnInit {
  @Input() idIntegrador: number;

  data: {
    dadosIntegrador: Cliente;
    apontamentos: IntegradorApontamento[];
    ultAcesso: Date;
    acessoUltMes: number;
  } = {
    dadosIntegrador: new Cliente(),
    apontamentos: [],
    ultAcesso: new Date(),
    acessoUltMes: 0,
  };

  loadingStates = {
    ultAcesso: true,
    acessoUltMes: true,
    dadosIntegrador: true,
    apontamentos: true,
  };

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private clienteService: ClienteService,
    private integradorApontamentoService: IntegradorApontamentoService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    private biService: CRMBIService
  ) {}

  ngOnInit() {
    this.carregarDados();
  }

  private carregarDados() {
    this.loadData("dadosIntegrador", "Não foi possível buscar dados do integrador.", () =>
      this.clienteService.consultarPorIdCliente(this.idIntegrador, true)
    );
    this.loadData("apontamentos", "Não foi possível buscar apontamentos do integrador.", () =>
      this.integradorApontamentoService.consultarComPaginacao(1, 10, "datahora", "desc", this.idIntegrador)
    );
    this.loadData("acessoUltMes", "Não foi possível encontrar a quantidade de acessos dos últimos 30 dias.", () =>
      this.biService.qtdAcessoUltMes(this.idIntegrador)
    );
    this.loadData("ultAcesso", "Não foi possível buscar o último acesso.", () =>
      this.biService.ultAcesso(this.idIntegrador)
    );
  }

  private loadData(propriedade: string, mensagemErro: string, serviceCall: () => Observable<any>) {
    this.loadingStates[propriedade] = true;
    serviceCall().subscribe(
      (data) => {
        if (propriedade === "apontamentos") {
          this.data[propriedade] = data.itens;
        } else {
          this.data[propriedade] = data;
        }

        this.loadingStates[propriedade] = false;
      },
      () => {
        this.loadingStates[propriedade] = false;
        this.notificacaoService.erro(mensagemErro);
      }
    );
  }

  valorCamposPersonalizados(item: ClienteCampoPersonalizadoSelecionado): string {
    if (item.descricaoCampoPersonalizadoItem) {
      return item.descricaoCampoPersonalizadoItem;
    }

    if (item.texto) {
      return item.texto;
    }

    if (item.itens && item.itens.length > 0) {
      return item.itens.map((i) => i.descricaoCampoPersonalizadoItem).join(", ");
    }

    return "Valor não encontrado.";
  }

  enviarMsg(contato: Cliente) {
    this.utilitarioService.conversarPeloWhatsapp(contato.cel, "");
  }

  dataHumanizada(data): string {
    if (data === null || data === undefined || !data) return "";

    data = data.toString();

    const now = new Date();
    const dateNasc = new Date(data);
    const diff = now.getTime() - dateNasc.getTime();

    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const textYears = years > 1 ? "anos" : "ano";
    const textDays = days > 1 ? "dias" : "dia";
    const textHours = hours > 1 ? "horas" : "hora";

    let result = "";

    if (years > 0) {
      result += `${years} ${textYears}`;
    }

    if (days > 0) {
      if (result.length > 0) {
        result += ", ";
      }
      result += `${days} ${textDays}`;
    }

    if (hours > 0) {
      if (result.length > 0) {
        result += " e ";
      }
      result += `${hours} ${textHours}`;
    }

    if (result.length === 0) {
      result = "0 horas";
    }

    return result + " atrás";
  }

  geraTextoSimplesNacional() {
    return this.clienteService.geraTextoSimplesNacional(this.data.dadosIntegrador);
  }

  geraTextoSimei() {
    return this.clienteService.geraTextoSimei(this.data.dadosIntegrador);
  }

  geraTextoAtualizacaoReceita() {
    return this.clienteService.geraTextoAtualizacaoReceita(this.data.dadosIntegrador);
  }
}
